"use strict";
self.addEventListener("push", function (event) {
    var notificationTitle = "EFC#2018";

    var notificationOptions = {
        body: "Welcome to EFC!",
        icon: "https://europeanfilmchallenge.eu/assets/img/logo.jpg",
        image: "https://europeanfilmchallenge.eu/assets/img/efc-notification-banner.jpg",
        tag: "efc-challenge",
        data: {
            url: "https://europeanfilmchallenge.eu/"
        }
    };

    if (event.data) {
        var dataJson = event.data.json();

        notificationTitle = dataJson.title;
        notificationOptions.body = dataJson.body;
    }

    event.waitUntil(
        Promise.all([
            self.registration.showNotification(notificationTitle, notificationOptions)
        ])
    );
});

self.addEventListener("notificationclick", function (event) {
    event.notification.close();

    var clickResponsePromise = Promise.resolve();
    if (event.notification.data && event.notification.data.url) {
        clickResponsePromise = clients.openWindow(event.notification.data.url);
    }

    event.waitUntil(Promise.all([clickResponsePromise]));
});
